import { render } from "./DocumentaryCard.vue?vue&type=template&id=37e1d27d&scoped=true"
import script from "./DocumentaryCard.vue?vue&type=script&lang=js"
export * from "./DocumentaryCard.vue?vue&type=script&lang=js"

import "./DocumentaryCard.vue?vue&type=style&index=0&id=37e1d27d&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e1d27d"]])

export default __exports__